<template>
    <div class="wrapper-bg">
        <div class="header-page">
            <a class="btn-back" @click="clickBack">
                <img src="@/assets/icon-back.svg" />
            </a>
            <span class="lbl-header">ภารกิจเมนูแจกแต้ม</span>
        </div>
        <div class="coffee-nofooter mission-badge">
            <div class="quote-mission">
                <div class="title">{{ header.first }}</div>
                <div class="title-second">{{ header.second }}</div>
                <div class="detail" @click="openModal">ดูรายละเอียด</div>
            </div>
            <ul
                class="mission-list"
                v-for="(item, index) in missionList"
                :key="index"
            >
                <li
                    class="mission-item"
                    :class="{ complete: item.IsCompleted }"
                >
                    <div class="left-container">
                        <div class="image-container">
                            <img
                                class="image-cup"
                                :src="item.imageUrl"
                                alt=""
                            />
                            <img
                                v-if="item.IsCompleted"
                                class="image-point"
                                src="@/assets/icon/bg_point_gray.svg"
                                alt=""
                            />
                            <img
                                v-else
                                class="image-point"
                                src="@/assets/icon/bg_point_red.svg"
                                alt=""
                            />
                            <span
                                class="point-long"
                                v-if="item.point && item.point >= 10"
                                >+{{ item.point }}</span
                            >
                            <span class="point" v-else>+{{ item.point }}</span>
                        </div>
                        <div class="complete" v-if="item.IsCompleted">
                            <img src="@/assets/icon/gray_check.svg" alt="" />
                            สำเร็จแล้ว
                        </div>
                        <div class="incomplete" v-else>ยังไม่สำเร็จ</div>
                    </div>
                    <div class="right-container">
                        <div
                            class="mission-title"
                            :class="{ complete: item.IsCompleted }"
                        >
                            {{ item.Title }}
                        </div>
                        <div
                            class="mission-desc"
                            :class="{ complete: item.IsCompleted }"
                        >
                            {{ item.desc }}
                        </div>
                        <div class="mission-progressbar">
                            <div class="progressbar-inactive"></div>
                            <span
                                :style="{
                                    width:
                                        percent(item.Value, item.Current) + '%',
                                }"
                                class="progressbar-active"
                            ></span>
                            <span v-for="index in item.Value - 1" :key="index">
                                <span
                                    :style="{
                                        left: percent(item.Value, index) + '%',
                                    }"
                                    class="milestone"
                                ></span>
                            </span>
                        </div>
                        <div class="amount-container">
                            <span
                                class="amount"
                                :class="{ complete: item.IsCompleted }"
                                >จำนวนแก้ว
                            </span>
                            <span
                                class="amount"
                                :class="{ complete: item.IsCompleted }"
                                >{{ item.Current }}/{{ item.Value }}</span
                            >
                        </div>
                    </div>
                </li>
            </ul>
            <div class="footer-logo">
                <img
                    class="bzb_logo_profile"
                    src="../../../assets/icon/bzb_logo_profile_new.svg"
                />
            </div>
        </div>
        <b-modal
            id="modalMission"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
        >
            <div class="modal-mission">
                <div class="header">
                    <div class="modal-title">รายละเอียด</div>
                    <div
                        class="close-btn"
                        @click="$bvModal.hide('modalMission')"
                    >
                        <img src="@/assets/profile/close-new.svg" alt="" />
                    </div>
                </div>
                <ol
                    v-for="(item, index) of modalDesc"
                    :key="index"
                    class="modal-desc"
                >
                    <li class="desc-item">
                        <div class="number">{{ index + 1 }}.</div>
                        <div class="desc">{{ item }}</div>
                    </li>
                </ol>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Mixin from "@/mixin/Mixin";
//component//

//api//
import MenuApi from "@/module/Menu/service/missionbadge.js";

export default {
    name: "MissionBadge",
    data: function () {
        return {
            modalDesc: [],
            missionList: [],
            header: {
                first: "",
                second: "",
            },
        };
    },
    mixins: [Mixin],
    created: function () {
        this.handleLoading(true);
        const getMission = this.getMission();
        const getMissionBlob = this.getMissionBlob();

        Promise.all([getMission, getMissionBlob])
            .then(() => {
                this.calculateProgress();
                this.handleLoading(false);
            })
            .catch((err) => {
                this.handleLoading(false);
                console.log(err);
            });
    },
    methods: {
        getMissionBlob() {
            return new Promise((resolve, reject) => {
                MenuApi.GetBadgeDetailBlob()
                    .then((response) => {
                        response.data.detail.forEach((element) => {
                            this.modalDesc.push(element);
                        });
                        this.header.first = response.data.Header.first;
                        this.header.second = response.data.Header.second;
                        console.log(response.data);
                        resolve(response.data);
                    })
                    .catch((err) => {
                        console.log("error ::::    ", err);
                        reject(err);
                    });
            });
        },
        getMission() {
            return new Promise((resolve, reject) => {
                MenuApi.GetMissionBadges().subscribe(
                    (res) => {
                        res.forEach((item) => {
                            console.log(item);
                            if (
                                item.CustomInfo &&
                                item.CustomInfo.includes("campaignId")
                            ) {
                                let campaignId = item.CustomInfo.split(":")[1];
                                let image;
                                MenuApi.GetMissionBadgeImage(campaignId)
                                    .then((response) => {
                                        image = response.config.url;
                                        console.log(image);
                                        this.missionList.push({
                                            imageUrl: image,
                                            point: item.Points,
                                            Title: item.Name,
                                            Value: item.Missions[0].Value,
                                            Current: item.Missions[0].Current,
                                            IsCompleted:
                                                item.Missions[0].IsCompleted,
                                            desc: item.Description,
                                        });
                                    })
                                    .catch((err) => {
                                        //mission with no imageUrl
                                        this.missionList.push({
                                            imageUrl: "",
                                            point: item.Points,
                                            Title: item.Name,
                                            Value: item.Missions[0].Value,
                                            Current: item.Missions[0].Current,
                                            IsCompleted:
                                                item.Missions[0].IsCompleted,
                                            desc: item.Description,
                                        });
                                        console.log("error ::::    ", err);
                                    });
                            }
                        });
                        resolve(res);
                    },
                    (err) => {
                        console.log("redeem error", err);
                        reject(err);
                    }
                );
            });
        },
        openModal() {
            this.$bvModal.show("modalMission");
        },
        percent(max, current) {
            return (current / max) * 100;
        },
        calculateProgress() {
            for (let i = 0; i < this.missionList.length; i++) {
                this.missionList[i].progress =
                    (100 / this.missionList[i].Value) *
                    this.missionList[i].Current;
            }
        },
        clickBack() {
            this.$router.push(`/privilege`);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/module/Order/style/orderStyle.scss";
@import "@/style/modal.scss";
@import "@/module/Menu/style/mission.scss";
.mission-badge {
    color: #fff;
    .mission-list {
        padding: 25px;
        .mission-item {
            position: relative;
            z-index: 5;
            display: flex;
            background-color: $color-light-grey-500;
            padding: 10px 15px 15px;
            border-radius: 15px;
            .left-container {
                font-family: "PromptSemibold";
                font-size: 14px;
                text-align: center;
                .image-container {
                    position: relative;
                    top: -25px;
                    .image-cup {
                        height: 80px;
                    }
                    .image-point {
                        height: 45px;
                        position: absolute;
                        left: 40px;
                        bottom: 45px;
                    }
                    .point {
                        font-family: "DBHeaventRounded";
                        font-size: 24px;
                        left: 53px;
                        top: -6px;
                        position: absolute;
                    }
                    .point-long {
                        font-family: "DBHeaventRounded";
                        font-size: 19px;
                        left: 50px;
                        top: -2px;
                        position: absolute;
                    }
                }
                .complete {
                    margin-top: -10px;
                    color: $color-text;
                    img {
                        margin-top: -3px;
                    }
                }
                .incomplete {
                    margin-top: -10px;
                    color: $color-brown-50;
                }
            }
            .right-container {
                margin-left: 6px;
                width: 100%;
                color: #4d341c;
                .mission-title {
                    font-size: 16px;
                    font-family: "PromptSemiBold";
                    color: $color-text;
                }
                .mission-desc {
                    font-family: "PromptRegular";
                    font-size: 14px;
                    color: $color-text-light;
                }
                .mission-progressbar {
                    width: 100%;
                    position: relative;
                    margin: 16px 0 5px;
                    .progressbar-active {
                        background-image: linear-gradient(
                            to right,
                            #8f735d 0%,
                            #b79377 100%
                        );
                        height: 5px;
                        position: absolute;
                        border-radius: 10px;
                        margin-top: -5px;
                        z-index: 5;
                    }
                    .progressbar-inactive {
                        background-color: #fff;
                        border-radius: 10px;
                        width: 100%;
                        height: 5px;
                    }
                    .milestone {
                        width: 2px;
                        height: 5px;
                        background-color: #eee9e3;
                        position: absolute;
                        margin-top: -5px;
                        z-index: 3;
                    }
                }
                .amount-container {
                    display: flex;
                    justify-content: space-between;
                    .amount {
                        font-family: "PromptRegular";
                        font-size: 12px;
                        color: $color-text;
                    }
                }
            }
        }
    }
    .footer-logo {
        position: fixed;
        bottom: 20px;
        left: calc(50vw - 42.5px);
        z-index: 0;
        .bzb_logo_profile {
            width: 85px;
        }
    }
}
::v-deep #modalMission {
    .modal-mission {
        .header {
            display: block;
            padding: 0;
            .modal-title {
                color: $color-text;
            }
            .close-btn {
                margin-top: -50px;
                float: right;
            }
        }
    }
}
</style>
